<template>
  <div>
    <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-row class="no-gutters" style="margin-top: 10px">
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-select solo v-model="closedTradTime" :items="dateOptions" item-text="label" item-value="value"
            label="Select date" append-icon="mdi-chevron-down" class="custom-select"></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12">
          <v-card class="pa-3 rounded-0 elevation-0 chart-tab" :color="$vuetify.theme.dark ? '#172233' : '#E0EAF2'">
            <v-sheet v-if="singleAccountProfitLossSummary" class="pb-3"
              :color="$vuetify.theme.dark ? '#1A2A3E ' : '#E8F1F8'">
              <apexChart width="100%" height="338px" type="bar" :options="options" :series="series"
                class="liveTradeChart">
              </apexChart>
            </v-sheet>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { CHARTS__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      options: {
        chart: {
          id: "vuechart-example",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          labels: {
            style: {
              colors: "#708AA7",
            },
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: "#708AA7",
            },
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          crosshairs: {
            show: true,
            position: "back",
            stroke: {
              color: "#b6b6b6",
              width: 1,
              dashArray: 0,
            },
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "40%",
            colors: {
              ranges: [
                {
                  from: 0,
                  to: Infinity,
                  color: "#14D7B2",
                },
                {
                  from: -Infinity,
                  to: 0,
                  color: "#647E98",
                },
              ],
            },
          },
        },
        // noData: {
        //   text: 'No Data Found',
        //   align: 'center',
        //   verticalAlign: 'middle',
        //   offsetX: 0,
        //   offsetY: 0,
        //   style: {
        //     color: undefined,
        //     fontSize: '14px',
        //     fontFamily: undefined
        //   }
        // },
        // colors: [],
        dataLabels: {
          enabled: false,
        },
        grid: {
          show: false,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          show: true,
          showForSingleSeries: true,
          customLegendItems: ["Profit / Loss"],
          // customLegendItems: ["Profit", "Loss"],
          labels: {
            colors: ["#647E98"],
            useSeriesColors: false,
          },
          markers: {
            // fillColors: ["#14D7B2", "#647E98"],
            fillColors: ["#14D7B2", "#647E98"],
            radius: 12,
          },
        },
      },
      time: "last-week",
      closedTradTime: "last-week",
      dateOptions: [
        { label: "Last Week", value: "last-week" },
        { label: "Last Month", value: "last-month" },
        { label: "Last Year", value: "last-year" }
      ]
    };
  },

  computed: {
    series() {
      const seriesData = [
        {
          name: "Amount",
          data:
            this.singleAccountProfitLossSummary?.data?.map((item) => ({
              x: item.Time.split("-").reverse().join("."),
              y:
                parseFloat(item.totalProfit) >= 0
                  ? parseFloat(item.totalProfit)
                  : -1 * parseFloat(item.totalProfit),
              goals: [
                {
                  name: parseFloat(item.totalProfit) >= 0 ? "Profit" : "Loss",
                  value: parseFloat(item.totalProfit),
                  strokeHeight: 5,
                  strokeColor:
                    parseFloat(item.totalProfit) >= 0 ? "transparent" : "red",
                },
              ],
            })) || [],
        },
      ];

      this.options.xaxis.categories =
        this.singleAccountProfitLossSummary?.labels || [];

      return seriesData;
    },

    ...mapState("charts", ["singleAccountProfitLossSummary"]),
  },

  methods: {
    ...mapActions("charts", [CHARTS__ACTIONS.SINGLEACCOUNTPROFITLOSSSUMMARY]),

    async fetchChartData(time, id) {
      const data = { time, id };
      await this[CHARTS__ACTIONS.SINGLEACCOUNTPROFITLOSSSUMMARY](data);
    },
  },

  watch: {
    async closedTradTime(newTime, oldTime) {
      if (newTime !== oldTime) {
        try {
          await this.fetchChartData(newTime, this.$route.query.id);
        } catch (error) {
          console.error(error);
        }
      }
    },
  },

  async mounted() {
    const data = { time: this.time, id: this.$route.query.id };
    await this[CHARTS__ACTIONS.SINGLEACCOUNTPROFITLOSSSUMMARY](data);
  },
};
</script>
